/* PC Praha – přepínač ceny elektřiny pro výnos na kartách minerů (20. 10. 2026).
   Jeden kód pro všechny kolekce: sekce pcp-kolekce-domaci (FVE / výkupní cena / vlastní cena)
   i pcp-kolekce-asic (náš hosting / vlastní cena / bez elektřiny). Možnosti se definují v markupu:

   <pcp-tariff data-mode="hosting" data-store="pcpTariffAsic" data-seed="pcpTariff:home:own">
     <button class="pcp-tf__opt" data-mode="hosting" data-kwh="1.14" data-note="hosting {kwh} Kč/kWh">…</button>
     <span class="pcp-tf__opt pcp-tf__opt--in" data-mode="own"><button class="pcp-tf__in-btn">…</button>
       <label class="pcp-tf__kwh"><input data-k="own" …></label></span>
     <button class="pcp-tf__opt" data-mode="none" data-gross>Bez elektřiny</button>
   </pcp-tariff>

   data-kwh = pevná cena Kč/kWh, input[data-k=<mode>] = cena zadaná zákazníkem, data-gross = ukázat výnos bez elektřiny,
   data-note = text pod hodnotou na kartě ({kwh} = cena). data-store = klíč v localStorage (formát {mode, <k>: hodnota}),
   data-seed = „klíč:vlastnost:input“ – výchozí hodnota inputu z jiného uloženého nastavení (např. kalkulačka výnosnosti).

   Přepočítává:
   – panely karet .pcp-cy__panel[data-rev] (snippets/pcp-card-yield.liquid: data-rev, data-pw, data-price-h / -d), i karty
     dočtené nekonečným posouváním nebo filtry (MutationObserver na results-list),
   – buňky [data-pcp-tf-cell] s data-rev a data-pw (např. tabulka srovnání) → zisk / den,
   – texty [data-pcp-tf-lbl] („Zisk / den“ / „Výnos / den“) a [data-pcp-tf-note] (popis zvolené ceny).
   Po každé změně pošle událost „pcp:tariff“ ({ mode, kwh, gross, vat, host, label }) na document.
   Překlady (22. 10. 2026): texty z window.PCP.T (klíče tf.*, pay.* – snippets/pcp-i18n.liquid), čísla přes PCP.nl. */
(function () {
  /* Společný výpočet pro karty, tabulku i filtry (assets/pcp-asic-filtry.js, 23. 10. 2026):
     zisk / den = výnos − příkon × 24 h × Kč/kWh; návratnost v měsících = cena ÷ zisk ÷ 30,4 (bez ceny / bez zisku = ∞).
     PCP.tariff = { mode, kwh, gross } – aktuální volba přepínače (nastaví se při každém přepočtu). */
  window.PCP = window.PCP || {};
  if (!window.PCP.tfCalc) {
    window.PCP.tfCalc = function (rev, pw, price, kwh) {
      var profit = rev - pw * 24 * kwh / 1000;
      return { profit: profit, months: profit > 0 && price > 0 ? price / profit / 30.4 : Infinity };
    };
  }
  /* Cena pro návratnost a zobrazenou cenu (23. 10. 2026, Yegor) – JEDINÉ místo, kde se rozhoduje, ze které ceny se počítá
     (karty, filtry, řazení, hlavní stránka). Režim provozu „Na našem hostingu“ (mode hosting / host) → cena varianty
     Na hosting bez DPH; bez hostingové varianty a ve všech ostatních režimech (Doma / vlastní cena, bez elektřiny, FVE /
     výkup v sekci Domácí těžba) → cena Doma s DPH, s volbou „Ceny: bez DPH“ (vat === false, jen sections/pcp-provoz)
     Doma ÷ 1,21. Na hostingu se volba DPH nepoužije (cena na hosting je vždy bez DPH). Bez přepínače (mode prázdný)
     rozhoduje cena elektřiny: > 0 hosting, jinak Doma (stejně jako první vykreslení ve snippets/pcp-card-yield.liquid).
     Ceny v Kč ze snippets/pcp-pay-price.liquid. src = 'h' (hosting) | 'd' (Doma s DPH) | 'n' (Doma bez DPH).
     PCP.tfPrice(ph, pd, mode, kwh, vat) – cena varianty výnosu (návratnost); PCP.tfShown(hmin, dmin, …) – zobrazená
     cena „od“ na kartě v2 (filtr ceny, řazení podle ceny); PCP.tfPanelPrice(panel, mode, kwh, vat) čte data-* panelu
     (starší markup jen s data-price → ta); PCP.tfSrc(panel, src) přepíše title / text pro čtečky u hodnoty Návratnost. */
  if (!window.PCP.tfPrice) {
    window.PCP.VAT = 1.21;
    window.PCP.tfHost = function (mode, kwh) { return mode ? (mode === 'hosting' || mode === 'host') : kwh > 0; };
    window.PCP.tfPrice = function (ph, pd, mode, kwh, vat) {
      if (window.PCP.tfHost(mode, kwh) && ph > 0) return { price: ph, src: 'h' };
      pd = pd > 0 ? pd : 0;
      if (vat === false && !window.PCP.tfHost(mode, kwh)) return { price: pd / window.PCP.VAT, src: 'n' };
      return { price: pd, src: 'd' };
    };
    window.PCP.tfShown = window.PCP.tfPrice;
    window.PCP.tfPanelPrice = function (pn, mode, kwh, vat) {
      var d = pn.dataset, pd = +d.priceD, ph = +d.priceH || 0;
      if (d.priceD == null || isNaN(pd)) pd = +d.price || 0;
      return window.PCP.tfPrice(ph, pd, mode, kwh, vat);
    };
    window.PCP.tfSrc = function (pn, src) {
      var t = pn.getAttribute('data-src-' + src) || pn.getAttribute('data-src-d');
      if (!t) return;
      var cells = pn.querySelectorAll('.pcp-cy__cell'), b = cells[1] && cells[1].querySelector('.pcp-cy__val');
      if (b) b.title = t;
      var sr = pn.querySelector('.pcp-cy__src');
      if (sr) sr.textContent = t;
    };
  }
  /* Karty v2 na kolekcích ASIC (23. 10. 2026, snippets/pcp-card-yield.liquid s pcp_k2): panel s data-k2, částka v Kč
     v data-k2czk (NE data-pcp-czk – ten by přepínač měny ve snippets/pcp-locale.liquid přepsal svým formátem s 2 desetinami).
     Jednotný formát částek: od 10 bez desetin, pod 10 dvě platné číslice (81 Kč · 8,1 Kč · 0,74 Kč; v € stejně, $ anglicky).
     Měnu a kurz bere z window.PCP.cur / PCP.rate (pcp-locale); po přepnutí měny (událost „pcp:currency“) přepíše [data-k2czk]. */
  if (!window.PCP.k2money) {
    var K2SYM = { CZK: 'Kč', EUR: '€', USD: '$' };
    window.PCP.k2money = function (czk) {
      var P1 = window.PCP || {}, cur = K2SYM[P1.cur] ? P1.cur : 'CZK', rate = (P1.rate && P1.rate[cur]) || 1;
      var v = cur === 'CZK' ? czk : czk / rate, a = Math.abs(v);
      var d = a >= 10 ? 0 : (a >= 1 ? 1 : (a > 0 ? Math.min(6, 1 - Math.floor(Math.log10(a))) : 0));
      var n = new Intl.NumberFormat(cur === 'USD' ? 'en-US' : (P1.nl || 'cs-CZ'), { maximumFractionDigits: d, minimumFractionDigits: 0 }).format(v).replace(/\s/g, ' ');
      return cur === 'USD' ? '$' + n : n + ' ' + K2SYM[cur];
    };
    document.addEventListener('pcp:currency', function () {
      document.querySelectorAll('[data-k2czk]').forEach(function (el) {
        var c = parseFloat(el.getAttribute('data-k2czk'));
        if (!isNaN(c)) el.textContent = window.PCP.k2money(c);
      });
    });
  }
  if (customElements.get('pcp-tariff')) return;
  var P = window.PCP || {};
  var NL = P.nl || 'cs-CZ';
  var T = function (k, v, fb) { var s = P.T && P.T[k] != null ? P.t(k, v) : fb; return s; };

  var fmt = function (n) {
    return (n < 100
      ? n.toLocaleString(NL, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : Math.round(n).toLocaleString(NL)).replace(/\s/g, ' ');
  };
  var money = function (abs) {
    var cur = window.PCP && window.PCP.cur && window.PCP.cur !== 'CZK' && window.PCP.format ? window.PCP.format : null;
    return cur ? cur(abs) : fmt(abs) + ' Kč';
  };
  var payback = function (m) {
    if (P.payback && P.T && P.T['pay.never'] != null) return P.payback(m, 60);
    if (!(m < Infinity)) return 'nevyplatí se';
    if (m < 1) return 'do 1 měsíce';
    if (m > 60) return 'přes 5 let';
    var r = Math.round(m);
    return r === 1 ? '1 měsíc' : (r < 5 ? r + ' měsíce' : r + ' měsíců');
  };

  /* Provoz + ceny (23. 10. 2026, sections/pcp-provoz.liquid na kolekcích ASIC): druhá skupina tlačítek .pcp-tf__vat[data-vat]
     („Ceny: s DPH / bez DPH – pro firmy“). S ní element navíc:
     – nastaví html[data-pcp-pr] = h | d | n (která cena je na kartách v2 vidět, assets/pcp-karty.css),
     – v režimu hosting volbu DPH zašedí (disabled) a ukáže poznámku [data-pv-vnote],
     – s atributem data-url čte a zapisuje volbu do URL (?provoz=hosting|doma|bez&dph=1|0&kwh=4.5; URL má přednost
       před localStorage), ukládá i { vat } do data-store,
     – PCP.tariff / událost pcp:tariff mají navíc vat (true / false) a label (souhrn pro čip na telefonu). */
  var URLMODE = { hosting: 'hosting', doma: 'own', bez: 'none' }, MODEURL = { hosting: 'hosting', own: 'doma', none: 'bez' };
  customElements.define('pcp-tariff', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.opts = {};
      this.inputs = {};
      this.vats = [...this.querySelectorAll('.pcp-tf__vat[data-vat]')];
      this.vat = true;
      this.querySelectorAll('.pcp-tf__opt[data-mode]').forEach((o) => { this.opts[o.dataset.mode] = o; });
      this.querySelectorAll('input[data-k]').forEach((i) => { this.inputs[i.dataset.k] = i; });
      var store = this.dataset.store, saved = null;
      if (store) { try { saved = JSON.parse(localStorage.getItem(store) || 'null'); } catch (e) {} }
      if (saved) {
        Object.keys(this.inputs).forEach((k) => {
          var v = saved[k];
          if (v !== '' && v != null && parseFloat(String(v).replace(',', '.')) >= 0) this.inputs[k].value = v;
        });
        if (saved.mode && this.opts[saved.mode]) this.dataset.mode = saved.mode;
        if (this.vats.length && saved.vat != null) this.vat = saved.vat !== false && saved.vat !== '0';
      } else if (this.dataset.seed) {
        var p = this.dataset.seed.split(':'), seed = null;
        try { seed = JSON.parse(localStorage.getItem(p[0]) || 'null'); } catch (e) {}
        if (seed && parseFloat(seed[p[1]]) > 0 && this.inputs[p[2]]) this.inputs[p[2]].value = seed[p[1]];
      }
      if (this.hasAttribute('data-url')) {
        var q = new URLSearchParams(location.search), um = URLMODE[q.get('provoz')], uk = parseFloat(String(q.get('kwh') || '').replace(',', '.'));
        if (um && this.opts[um]) this.dataset.mode = um;
        if (uk >= 0 && uk <= 20 && this.inputs.own) this.inputs.own.value = uk;
        if (this.vats.length && (q.get('dph') === '0' || q.get('dph') === '1')) this.vat = q.get('dph') === '1';
      }
      Object.keys(this.opts).forEach((m) => {
        var o = this.opts[m];
        var b = o.tagName === 'BUTTON' ? o : o.querySelector('.pcp-tf__in-btn');
        if (b) b.addEventListener('click', () => this.set(m, true));
      });
      Object.keys(this.inputs).forEach((k) => {
        var i = this.inputs[k];
        i.addEventListener('focus', () => this.set(k, true));
        i.addEventListener('input', () => this.set(k, true));
      });
      this.vats.forEach((b) => b.addEventListener('click', () => { if (b.disabled) return; this.vat = b.dataset.vat !== '0'; this.set(this.dataset.mode, true); }));
      var target = document.querySelector('results-list') || document.body;
      this.mo = new MutationObserver(() => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => { this._raf = 0; this.apply(); });
      });
      this.mo.observe(target, { childList: true, subtree: true });
      var first = Object.keys(this.opts)[0];
      this.set(this.opts[this.dataset.mode] ? this.dataset.mode : first, false);
    }
    disconnectedCallback() { if (this.mo) this.mo.disconnect(); }
    num(k) { var i = this.inputs[k]; var v = i ? parseFloat(String(i.value).replace(',', '.')) : 0; return v > 0 ? v : 0; }
    kwh() {
      var o = this.opts[this.dataset.mode];
      if (!o) return 0;
      if (o.hasAttribute('data-kwh')) { var v = parseFloat(o.dataset.kwh); return v > 0 ? v : 0; }
      return this.inputs[this.dataset.mode] ? this.num(this.dataset.mode) : 0;
    }
    kwhS(kwh) {
      var s = String(Math.round(kwh * 100) / 100);
      return P.lang !== 'en' ? s.replace('.', ',') : s;
    }
    note(kwh) {
      var o = this.opts[this.dataset.mode], kwhS = this.kwhS(kwh);
      if (o && o.dataset.note) return o.dataset.note.replace('{kwh}', kwhS);
      return kwh > 0 ? T('tf.at', { kwh: kwhS }, 'při ' + kwhS + ' Kč/kWh') : T('tf.none', null, 'bez elektřiny');
    }
    vatOn() { return this.vats.length ? this.vat : true; }
    label(mode, kwh, host) {
      var o = this.opts[mode], parts = [];
      if (o) parts.push(o.dataset.short || (o.querySelector('.pcp-tf__in-btn') || o).textContent.trim());
      if (kwh > 0) parts.push(this.kwhS(kwh) + ' Kč/kWh');
      if (this.vats.length) {
        var vb = this.vats.filter((b) => (b.dataset.vat !== '0') === (host ? false : this.vat))[0];
        if (host && this.dataset.tHost) parts.push(this.dataset.tHost);
        else if (vb) parts.push(vb.dataset.short || vb.textContent.trim());
      }
      return parts.join(' · ');
    }
    set(mode, user) {
      if (!this.opts[mode]) return;
      this.dataset.mode = mode;
      Object.keys(this.opts).forEach((m) => { var o = this.opts[m], v = m === mode ? 'true' : 'false'; if (o.tagName === 'BUTTON') o.setAttribute('aria-pressed', v); else { o.dataset.pressed = v; var ib = o.querySelector('button'); if (ib) ib.setAttribute('aria-pressed', v); } });
      if (this.vats.length) {
        var host = P.tfHost(mode, this.kwh());
        this.vats.forEach((b) => {
          var on = host ? b.dataset.vat === '0' : (b.dataset.vat !== '0') === this.vat;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.disabled = host;
        });
        this.classList.toggle('is-host', host);
        var vn = this.querySelector('[data-pv-vnote]') || document.querySelector('[data-pv-vnote]');
        if (vn) vn.hidden = !host;
        document.documentElement.setAttribute('data-pcp-pr', host ? 'h' : (this.vat ? 'd' : 'n'));
      }
      this.apply(true);
      if (user && this.dataset.store) {
        var data = { mode: mode };
        Object.keys(this.inputs).forEach((k) => { data[k] = this.inputs[k].value; });
        if (this.vats.length) data.vat = this.vat;
        try { localStorage.setItem(this.dataset.store, JSON.stringify(data)); } catch (e) {}
      }
      if (user && this.hasAttribute('data-url') && /^https?:/.test(location.protocol)) {
        try {
          var u = new URL(location.href), q = u.searchParams;
          q.set('provoz', MODEURL[mode] || mode);
          if (this.vats.length && !P.tfHost(mode, this.kwh())) q.set('dph', this.vat ? '1' : '0'); else q.delete('dph');
          if (mode === 'own') q.set('kwh', String(this.num('own'))); else q.delete('kwh');
          history.replaceState(history.state, '', u.pathname + '?' + q.toString().replace(/%2C/g, ',') + u.hash);
        } catch (e) {}
      }
    }
    apply(force) {
      var mode = this.dataset.mode, kwh = this.kwh(), vat = this.vatOn();
      var o = this.opts[mode], gross = !!(o && o.hasAttribute('data-gross'));
      var key = mode + ':' + kwh + ':' + (vat ? 1 : 0), note = this.note(kwh);
      document.querySelectorAll('.pcp-cy__panel[data-rev]').forEach((pn) => {
        if (!force && pn.dataset.pcpKey === key) return;
        pn.dataset.pcpKey = key;
        var rev = +pn.dataset.rev, pw = +pn.dataset.pw, pp = P.tfPanelPrice(pn, mode, kwh, vat), price = pp.price;
        if (!(rev > 0)) return;
        var cr = P.tfCalc(rev, pw, price, kwh), profit = cr.profit, m = cr.months;
        if (price > 0) P.tfSrc(pn, pp.src);
        var cells = pn.querySelectorAll('.pcp-cy__cell');
        var lbl = cells[0] && cells[0].querySelector('.pcp-cy__lbl'), val = cells[0] && cells[0].querySelector('.pcp-cy__val');
        var pb = cells[1] && cells[1].querySelector('.pcp-cy__val'), nt = pn.querySelector('.pcp-cy__note');
        var shown = gross ? rev : profit;
        if (lbl) lbl.textContent = gross ? T('tf.rev', null, 'Výnos / den') : T('tf.profit', null, 'Zisk / den');
        if (val) {
          var abs = Math.abs(shown);
          var k2 = pn.hasAttribute('data-k2');
          val.innerHTML = (shown < 0 ? '−' : (pn.hasAttribute('data-pcp-az') ? T('tf.upto', null, 'až') + ' ' : '≈ ')) + '<span ' + (k2 ? 'data-k2czk="' + abs.toFixed(2) + '">' + P.k2money(abs) : 'data-pcp-czk="' + abs.toFixed(2) + '">' + money(abs)) + '</span>';
          val.classList.toggle('pcp-cy__val--g', shown > 0);
          val.classList.toggle('pcp-cy__val--neg', shown <= 0);
        }
        /* bez ceny (cena na dotaz, data-price = 0): návratnost necháme z Liquidu („na dotaz“) */
        if (pb && price > 0) { pb.textContent = payback(m); pb.classList.toggle('pcp-cy__val--neg', !(m < Infinity)); }
        if (nt) nt.textContent = note;
      });
      if (force) {
        document.querySelectorAll('[data-pcp-tf-cell]').forEach((c) => {
          var rev = +c.dataset.rev, pw = +c.dataset.pw;
          if (!(rev > 0)) return;
          var v = gross ? rev : P.tfCalc(rev, pw, 0, kwh).profit, abs = Math.abs(v);
          c.innerHTML = (v < 0 ? '−' : '') + '<span data-pcp-czk="' + abs.toFixed(2) + '">' + money(abs) + '</span>';
          c.classList.toggle('is-pos', v > 0);
          c.classList.toggle('is-neg', v <= 0);
        });
        document.querySelectorAll('[data-pcp-tf-lbl]').forEach((l) => { l.textContent = gross ? T('tf.rev', null, 'Výnos / den') : T('tf.profit', null, 'Zisk / den'); });
        document.querySelectorAll('[data-pcp-tf-note]').forEach((l) => { l.textContent = note; });
        var host = P.tfHost(mode, kwh), label = this.label(mode, kwh, host);
        P.tariff = { mode: mode, kwh: kwh, gross: gross, vat: vat, host: host, label: label };
        document.dispatchEvent(new CustomEvent('pcp:tariff', { detail: { mode: mode, kwh: kwh, gross: gross, vat: vat, host: host, label: label } }));
      }
    }
  });
})();
